import React from "react";
import "./LegalPages.css";

const MapaSitio = () => (
  <div className="legal-page">
    <h1>Mapa del Sitio</h1>

    <section>
      <h2>Secciones Principales</h2>
      <ul>
        <li><a href="/about">Quiénes Somos</a></li>
        <li><a href="/projects">Nuestros Proyectos</a></li>
        <li><a href="/#contact">Contacto</a></li>
      </ul>
    </section>

    <section>
      <h2>Información Legal</h2>
      <ul>
        <li><a href="/politica-privacidad">Política de Privacidad</a></li>
        <li><a href="/uso-cookies">Uso de Cookies</a></li>
        <li><a href="/condiciones-de-uso">Condiciones de Uso</a></li>
        <li><a href="/avisos-legales">Aviso Legal</a></li>        
        <li><a href="/portal-transparencia">Transparencia</a></li>
      </ul>
    </section>

    <section>
      <h2>Contacto Rápido</h2>
      <ul>
        <li><a href="https://wa.me/34680339168" target="_blank" rel="noopener noreferrer">WhatsApp</a></li>
        <li><a href="mailto:info@sparklingtech.es">Email: info@sparklingtech.es</a></li>
        <li><a href="https://es.linkedin.com/company/sparklingtechsolutions" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
        <li><a href="https://www.instagram.com/sparklingtech.es/" target="_blank" rel="noopener noreferrer">Instagram</a></li>
      </ul>
    </section>
  </div>
);

export default MapaSitio;
